import { render, staticRenderFns } from "./newPermission.vue?vue&type=template&id=4af15bb2&"
import script from "./newPermission.vue?vue&type=script&lang=js&"
export * from "./newPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports